import feathers from 'feathers/client'
import socketio from 'feathers-socketio/client'
import hooks from 'feathers-hooks'
import auth from 'feathers-authentication-client'
import io from 'socket.io-client/dist/socket.io'

const FEATHERS_URI = '/'

const socket = io(FEATHERS_URI)

const feathersClient = feathers()
  .configure(socketio(socket, { timeout: 20000 }))
  .configure(hooks())
  .configure(
    auth({
      storage: window.localStorage,
    }),
  )

export default feathersClient

if (process.env.NODE_ENV !== 'production') {
  global.app = feathersClient
}



// WEBPACK FOOTER //
// ./src/feathers.js